module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-module mb"
  }, [_c('div', {
    staticClass: "perStore clearfix",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "id": "gtwdDiv"
    }
  }, _vm._l((_vm.list), function(store) {
    return _c('div', {
      key: store.storeId,
      staticClass: "perStore-item"
    }, [_c('router-link', {
      staticClass: "brand-img",
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        }
      }
    }, [_c('img', {
      staticClass: "scrollLoading",
      attrs: {
        "src": store.storeBanner
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "perStore-info"
    }, [_c('span', {
      staticClass: "brand-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 1,
            store_id: store.storeId
          }
        }
      }
    }, [_vm._v("\n            " + _vm._s(store.storeName) + "\n          ")])], 1), _vm._v(" "), _c('p', {
      staticClass: "brand-time"
    }, [_vm._v("销售:" + _vm._s(store.totalBuyNum) + "   共" + _vm._s(store.totalGoodsNum) + "商品")])])], 1)
  }), 0), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "id": "gtwdDivLoadding"
    }
  }, [_vm._v("正在加载，请稍候 ...")]) : _vm._e(), _vm._v(" "), (!_vm.hasMore) ? _c('Alert', [_vm._v("没有更多数据")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c72b1ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/silver-shop/good-shop.vue
// module id = 1630
// module chunks = 1